module.exports = __webpack_public_path__ + "static/loading-22e93c980c648fc0664f86864d64e858.gif";